var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "vmlistImageOften",
      staticClass: "form-tag",
      class: { "on-mobile": _vm.$store.state.chat.isMobileMode }
    },
    _vm._l(_vm.listImageOften, function(item, index) {
      return _c(
        "el-row",
        { key: index, attrs: { gutter: 5 } },
        _vm._l(item, function(Image, i) {
          return _c(
            "el-col",
            {
              key: Image._id,
              staticClass: "uk-text-center word-break",
              attrs: { span: 4 }
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fnCheckShowFile(Image.link) == true,
                      expression: "fnCheckShowFile(Image.link) == true"
                    }
                  ],
                  on: {
                    click: function($event) {
                      return _vm.fnSendImageOftenToLine(Image.link)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "ui-path-img",
                    attrs: { src: Image.link }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.fnCheckShowFile(Image.link) == false,
                      expression: "fnCheckShowFile(Image.link) == false"
                    }
                  ],
                  on: {
                    click: function($event) {
                      return _vm.fnSendImageOftenToLine(Image.link)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "ui-path-img",
                    attrs: {
                      src:
                        "https://chat.mushroomtravel.com/storage-dev/14368/668eee00-3e6a-11ea-bd60-652740535233.png"
                    }
                  }),
                  _vm._v(" "),
                  _c("strong", {
                    directives: [
                      {
                        name: "nameFile",
                        rawName: "v-nameFile",
                        value: Image.link,
                        expression: "Image.link"
                      }
                    ],
                    staticClass: "uk-text-bold"
                  })
                ]
              )
            ]
          )
        }),
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c1b5a0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c1b5a0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageOften.vue
// module id = null
// module chunks = 